import { EDealTabs, EPostLocation, EPostType } from "../enums";
import { IChatsListFilter, IChatsMessagesFilter, IFilter, ISearchDealsFilter, ISearchPostFilter } from "../interfaces";
import { Pagination } from "./Pagination";

export class Filter extends Pagination implements IFilter {
    constructor() {
        super()
    }
}

export class SearchPostsFilter extends Filter implements ISearchPostFilter {
    searchType = EPostLocation.international;
    searchAs = EPostType.deliver;
    localCountryId!: number | null;
    fromCityId!: number | null;
    toCityId!: number | null;
    fromCountryId!: number | null;
    toCountryId!: number | null;
    // beforeDate: Date | string = moment(moment().add(1, 'day').format('YYYY-MM-DDTHH:mm:ss.000[Z]')).toDate();
    beforeDate!: string | null;
    weight!: string;
}

export class SearchDealsFilter extends Filter implements ISearchDealsFilter {
    status = EDealTabs.all;
    search?: string;
}
export class ChatsListFilter extends Filter implements IChatsListFilter {
    name = '';
    override limit: number = 100;
}
export class ChatsMessagesFilter extends Filter implements IChatsMessagesFilter {
    override limit: number = 30;
}
export class NotificationsFilter extends Filter implements IFilter {
    override limit: number = 10;
}
export class RatesFilter extends Filter implements IFilter {
    override limit: number = 12;
}
export class QrCodesFilter extends Filter implements IFilter {

}
export class InvoicesFilter extends Filter implements IFilter {

}